import '@/styles/globals.css'
import '@/styles/webflow/normalize.css'
import '@/styles/webflow/webflow.css'
import '@/styles/webflow/az-sandiego.webflow.css'
import '@/styles/interactions.css'
import '@/styles/grid.css'

import '@fontsource/open-sans/300.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/open-sans/800.css'
import '@fontsource/open-sans/300-italic.css'
import '@fontsource/open-sans/400-italic.css'
import '@fontsource/open-sans/600-italic.css'
import '@fontsource/open-sans/700-italic.css'
import '@fontsource/open-sans/800-italic.css'

import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/poppins/800.css'
import '@fontsource/poppins/900.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { useRouter } from 'next/router'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const router = useRouter()

    // Remount each page on navigation so the load/scroll animations replay and
    // GSAP cleans up its triggers, matching the original per-page behaviour.
    return <Component key={router.asPath} {...pageProps} />
}

export default App
